import { Helmet } from "react-helmet";
import GameServicesLayout from "../../sections/services/game/gameServicesLayout";

const GameServicesPage = () => {
    return (
        <>
            <Helmet>
                <title>code3x Gaming | Interactive, Engaging & Immersive Games</title>
                <meta name="description" content="code3x offers gaming services from concept to launch. We design and develop immersive digital games." />
                <meta name="keywords" content="code3x gaming services, game development, interactive games, digital gaming solutions, gaming studio, mobile games, browser games, interactive applications, leading gaming studio, Sri Lanka" />
                <link rel="canonical" href="https://code3x.tech/suite/games" />
            </Helmet>

            <GameServicesLayout />
        </>
    );
}

export default GameServicesPage;